export default (type) => ({
  props: {
    essay: {
      type: Object,
      required: true,
    },

    activeHighlightIndex: {
      type: Number,
      default: -1,
    },
  },

  // special for copy/paste (hide all actions)
  provide: {
    specialForCopyPaste: false,
  },

  data() {
    return {
      items: [],
      loading: true,
      selectedItem: "all",
    };
  },

  computed: {
    isNoRanges() {
      return (this.essay?.tags || []).includes("no-ranges");
    },
  },

  async created() {
    await this.getEssayTabData();
    this.loading = false;
  },

  watch: {
    // Watch for changes to essay.id and reload data when it changes
    "essay.id": {
      handler: async function (newId, oldId) {
        if (newId !== oldId) {
          this.loading = true;
          await this.getEssayTabData();
          this.loading = false;
        }
      },
      immediate: false,
    },
  },

  methods: {
    async getEssayTabData() {
      this.items =
        type === "feedback"
          ? this.essay.evaluationFeedback
          : this.essay.grammarFeedback;
      this.init();
    },

    init() {
      const initialItem =
        type === "feedback" ? "all" : this.items[0]?.id || "all";

      this.selectItem(initialItem);
    },

    selectItem(itemId) {
      this.selectedItem = itemId;
      this.$emit("updateActiveHighlightIndex", -1);
    },
  },
});
